/*@flow*/
import * as t from 'lib/t';
import { Id } from 'types/tcomb';
import mkTagTemplate from 'lib/templates/mkTagTemplate';

const config = {
  id: t.maybe(Id).opt({ type: 'hidden' }),
  status: t.String.options({
    template: 'StreetscapeIssueStatus',
    attrs: {
      placeholder: 'Choose status',
      classNamePrefix: 'Select',
    },
  }),
  theGeom: t.String.opt({ type: 'hidden' }),
  address: t.maybe(t.String).opt({
    label: 'Address',
    template: 'LocationPickerTemplate',
  }),
  mapLabel: t.maybe(t.String),
  category: t.String.opt({
    template: 'IssueCategory',
    attrs: {
      placeholder: 'Choose a category',
    },
  }),
  subcategories: t.maybe(t.list(t.String)).opt({
    template: 'IssueSubcategory',
    attrs: {
      placeholder: 'Choose a subcategory',
    },
  }),
  tags: t.maybe(t.list(t.String)).opt({
    template: mkTagTemplate('streetscape_issues'),
    attrs: {
      placeholder: 'Select...',
    },
  }),
  photoUrls: t.maybe(t.list(t.String)).opt({
    label: 'Photo(s)',
    template: 'PhotoUploaderTemplate',
    help: 'Photos must be larger than 600px wide.',
  }),
  streetscapeAssetId: t.maybe(Id).opt({ type: 'hidden' }),
  cost: t.maybe(t.Number).opt({
    label: 'Cost',
  }),
  notes: t
    .maybe(t.String)
    .opt({ type: 'textarea', template: 'TextEditorTemplate' }),
  details: t.maybe(t.String).opt({
    type: 'textarea',
    template: 'TextEditorTemplate',
  }),
  maintenanceDetails: t.maybe(t.String).opt({
    type: 'textarea',
  }),
  dateOfIncident: t.maybe(t.Date).opt({
    label: 'Date of Incident',
  }),
  timeOfIncident: t.maybe(t.String).opt({
    label: 'Time of Incident',
  }),
};
const streetscapeIssue = t
  .struct(config, 'StreetscapeIssue')
  .opt<any>({ legend: '' });

export default streetscapeIssue;
